export class LoanPayment {
  /**
   * @param {number} id
   * @param {number} profileId
   * @param {string} profileName
   * @param {number} projectId
   * @param {number} order
   * @param {number} amount
   * @param {string} status
   * @param {string|null} paymentRequestDate
   * @param {number} paymentPercentage
   * @param {boolean} hasFee
   * @param {number} feePercentage
   */
  constructor(
    id,
    profileId,
    profileName,
    projectId,
    order,
    amount,
    status,
    paymentRequestDate,
    paymentPercentage,
    hasFee,
    feePercentage
  ) {
    this.id = id;
    this.projectId = projectId;
    this.profileId = profileId;
    this.profileName = profileName;
    this.order = order;
    this.amount = amount;
    this.status = status;
    this.paymentRequestDate = paymentRequestDate;
    this.paymentPercentage = paymentPercentage;
    this.hasFee = hasFee;
    this.feePercentage = feePercentage;
  }

  /**
   * @returns {boolean}
   */
  isRequested() {
    return this.status === 'requested'
  }

  /**
   * @returns {boolean}
   */
  isPending() {
    return this.status === 'pending'
  }

  /**
   * @param {boolean} hasFee
   */
  setHasFee(hasFee) {
    this.hasFee = hasFee;
  }

  /**
   * @param {number} commission
   * @param {boolean} hasFee
   */
  changeSupplierFundingCommission(commission, hasFee) {
    this.impactaMasCommission = commission;
    this.setHasFee(hasFee);
  }
}
